var render = function render(){var _vm=this,_c=_vm._self._c;return _c('resize-box',{ref:"resizeBox",staticClass:"videoBox",attrs:{"resize-el":''},on:{"resize":_vm.resizeHander,"done":function($event){return _vm.resizeHander($event, 'done')}}},[_c('form',{attrs:{"onsubmit":"return false;"}},[_c('div',{attrs:{"id":_vm.idEl}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }